import {Component} from '@angular/core';
import {InBaseFrwComponent} from '../../inBaseFrwComponent';

@Component({
  selector: 'cmp-modal-footer',
  template: `<div class="modal-footer">
  <ng-content></ng-content>
</div>
`,
  styles: [``]
})
export class ModalFooterComponent extends InBaseFrwComponent {

  constructor() {
    super();
  }

}
